var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.8501C16.8467 10.8501 7.77002 19.9268 7.77002 31.0801C7.77002 42.2334 16.8467 51.3334 28 51.3334C39.1534 51.3334 48.23 42.2568 48.23 31.1034C48.23 19.9501 39.1534 10.8501 28 10.8501ZM29.75 30.3334C29.75 31.2901 28.9567 32.0834 28 32.0834C27.0434 32.0834 26.25 31.2901 26.25 30.3334V18.6668C26.25 17.7101 27.0434 16.9168 28 16.9168C28.9567 16.9168 29.75 17.7101 29.75 18.6668V30.3334Z",
    fill: "#D8DEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7433 8.05008H21.2567C20.3233 8.05008 19.5767 7.30341 19.5767 6.37008C19.5767 5.43675 20.3233 4.66675 21.2567 4.66675H34.7433C35.6767 4.66675 36.4233 5.41341 36.4233 6.34675C36.4233 7.28008 35.6767 8.05008 34.7433 8.05008Z",
    fill: "#D8DEF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.1fa8c40b62808fd527cf47511e008811.svg";
export { ForwardRef as ReactComponent };